/**
 * BL-285: "Zuletzt besucht"-Verlauf für die Sidebar -- reine MRU-Logik
 * (kein React/DOM), Persistenz-Wrapper liegt in `use-recent-pages.ts`.
 * Speichert nur `NavItem.to`-Pfade, keine Icons/Labels (nicht
 * JSON-serialisierbar bzw. können sich ändern) -- beim Rendern wird gegen
 * die aktuelle NAV-Liste aufgelöst, siehe `navItemForPath` in
 * `app-sidebar-groups.ts`.
 */

export const RECENT_PAGES_STORAGE_KEY = 'fakt-recent-pages-v1';

/** Gespeicherte Historientiefe -- die aktuell aktive Seite wird beim Rendern
 *  zusätzlich herausgefiltert (siehe `use-recent-pages.ts`), sichtbar bleiben
 *  also bis zu MAX-1 "andere" Seiten. */
export const RECENT_PAGES_MAX = 5;

/**
 * Setzt `to` an den Anfang der MRU-Liste, entfernt einen bestehenden
 * Eintrag (kein Duplikat, keine Neuordnung der übrigen), kappt auf `max`.
 */
export function pushRecentPage(current: string[], to: string, max = RECENT_PAGES_MAX): string[] {
  return [to, ...current.filter((t) => t !== to)].slice(0, max);
}

function sameOrder(a: string[], b: string[]): boolean {
  return a.length === b.length && a.every((v, i) => v === b[i]);
}

/** `true`, wenn `pushRecentPage` die Liste tatsächlich verändern würde (Basis für einen No-Op-Guard). */
export function recentPagesChanged(current: string[], to: string, max = RECENT_PAGES_MAX): boolean {
  return !sameOrder(pushRecentPage(current, to, max), current);
}
